import { isKeyOf } from './guards.ts';
export type Rarity = 'common' | 'uncommon' | 'rare' | 'epic' | 'legendary';

export interface RarityDefinition {
  readonly label: string;
  /** Poids relatif d'apparition parmi les monstres d'une même zone. */
  readonly spawnWeight: number;
  /** Taux de capture de base (0..1), modulé par les PV restants. */
  readonly captureRate: number;
  /** Multiplicateur d'expérience accordée quand on bat ce monstre. */
  readonly xpMultiplier: number;
  readonly color: string;
}

export const RARITIES: Readonly<Record<Rarity, RarityDefinition>> = {
  common: { label: 'Commun', spawnWeight: 50, captureRate: 0.9, xpMultiplier: 1, color: '#9aa5b1' },
  uncommon: { label: 'Peu commun', spawnWeight: 25, captureRate: 0.7, xpMultiplier: 1.3, color: '#4caf50' },
  rare: { label: 'Rare', spawnWeight: 15, captureRate: 0.45, xpMultiplier: 1.7, color: '#2f80ed' },
  epic: { label: 'Épique', spawnWeight: 7, captureRate: 0.25, xpMultiplier: 2.2, color: '#9b51e0' },
  legendary: { label: 'Légendaire', spawnWeight: 3, captureRate: 0.1, xpMultiplier: 3, color: '#f2994a' },
};

export const RARITY_KEYS = Object.keys(RARITIES) as Rarity[];

export const isRarity = isKeyOf<Rarity>(RARITIES);
